import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
export class AiAgentApiRequestFactory extends BaseAPIRequestFactory {
    async createAIAgentSession(projectId, createSessionRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "createAIAgentSession", "projectId");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/sessions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(createSessionRequest, "CreateSessionRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteAIAgentSession(projectId, sessionId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "deleteAIAgentSession", "projectId");
        }
        if (sessionId === null || sessionId === undefined) {
            throw new RequiredError("AiAgentApi", "deleteAIAgentSession", "sessionId");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/sessions/{sessionId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'sessionId' + '}', encodeURIComponent(String(sessionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getAIAgentCard(_options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        const localVarPath = '/ai-agent/agent-card';
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getAIAgentSession(projectId, sessionId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "getAIAgentSession", "projectId");
        }
        if (sessionId === null || sessionId === undefined) {
            throw new RequiredError("AiAgentApi", "getAIAgentSession", "sessionId");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/sessions/{sessionId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'sessionId' + '}', encodeURIComponent(String(sessionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listAIAgentSessions(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "listAIAgentSessions", "projectId");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/sessions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async runAgentSse(projectId, runAgentRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "runAgentSse", "projectId");
        }
        if (runAgentRequest === null || runAgentRequest === undefined) {
            throw new RequiredError("AiAgentApi", "runAgentSse", "runAgentRequest");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/run-sse'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(runAgentRequest, "RunAgentRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async sendA2AMessage(sendA2AMessageRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (sendA2AMessageRequest === null || sendA2AMessageRequest === undefined) {
            throw new RequiredError("AiAgentApi", "sendA2AMessage", "sendA2AMessageRequest");
        }
        const localVarPath = '/ai-agent/a2a';
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(sendA2AMessageRequest, "SendA2AMessageRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateAIAgentSession(projectId, sessionId, updateSessionRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AiAgentApi", "updateAIAgentSession", "projectId");
        }
        if (sessionId === null || sessionId === undefined) {
            throw new RequiredError("AiAgentApi", "updateAIAgentSession", "sessionId");
        }
        if (updateSessionRequest === null || updateSessionRequest === undefined) {
            throw new RequiredError("AiAgentApi", "updateAIAgentSession", "updateSessionRequest");
        }
        const localVarPath = '/projects/{projectId}/ai-agent/sessions/{sessionId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'sessionId' + '}', encodeURIComponent(String(sessionId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateSessionRequest, "UpdateSessionRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class AiAgentApiResponseProcessor {
    async createAIAgentSessionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Session", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Invalid request", body, response.headers, response);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteAIAgentSessionWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getAIAgentCardWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "any", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getAIAgentSessionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Session", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Session not found", body, response.headers, response);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listAIAgentSessionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Array<Session>", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async runAgentSseWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "string", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Session not found", body, response.headers, response);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async sendA2AMessageWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "any", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Invalid request", body, response.headers, response);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateAIAgentSessionWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Session", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Session not found", body, response.headers, response);
        }
        if (isCodeInRange("502", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "ListAIAgentSessions502Response", "");
            throw new ApiException(response.httpStatusCode, "Failed to reach AI agent service", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
